export const ACCOUNT_NAME_DESKTOP_ELEMENT = document.getElementById('accountNameId');
export const TRANSFER_ACCOUNT_NAME = 'TRANSFER_ACCOUNT_NAME';
